// extracted by mini-css-extract-plugin
module.exports = {"button":"PageButton_button__Oq0Al","dark":"PageButton_dark__2_ZWW","tab":"PageButton_tab__3f8ve","content":"PageButton_content__3MNCE","active":"PageButton_active__zLTgp"};